import { Action, getModule, Module, Mutation, VuexModule } from 'vuex-module-decorators';
import { store } from '../..';
import { GEnum } from '@/constants/enum.defination';
import { evalSettingService } from '@/service/api/eval-setting.service';
import { UpdateEvalSettingSimpleRequest } from '@/models/evalSetting/eval-setting-simple';

// 生徒一覧取得画面用のstore
export interface IEvalSettingListState {
  viewMode: number; // 表示モード(カード形式 or テーブル形式)
  currentPageNum: number; // 現在参照しているのページ番号
  hasStatusCompleted: GEnum.RadioLabel; // 終了受検含有有無
}
@Module({ dynamic: true, store, name: 'evalSettingListModule', namespaced: true })
class EvalSettingListModule extends VuexModule implements IEvalSettingListState {
  viewMode: number = 1; // 表示モード(カード形式 or テーブル形式)
  currentPageNum: number = 1; // 現在参照しているのページ番号
  hasStatusCompleted: GEnum.RadioLabel = GEnum.RadioLabel.True;

  @Mutation
  setViewMode(value: number) {
    this.viewMode = value;
  }

  @Mutation
  setCurrentPageNum(value: number) {
    this.currentPageNum = value;
  }

  @Mutation
  setHasStatusCompleted(value: GEnum.RadioLabel) {
    this.hasStatusCompleted = value;
  }

  @Mutation
  clean() {
    this.viewMode = 1;
    this.currentPageNum = 1;
    this.hasStatusCompleted = GEnum.RadioLabel.True;
  }

  @Action({ rawError: true })
  updateEvalSettingSimple(request: UpdateEvalSettingSimpleRequest) {
    evalSettingService.updateEvalSettingSimple(request);
  }
}

export const evalSettingListModule = getModule(EvalSettingListModule);
